import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import api from '../config/api';
import './Auth.css';

const MagicLinkVerify = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setError('Token manquant');
        setLoading(false);
        return;
      }

      try {
        console.log('Verifying magic link token:', token);
        const response = await api.get(`/auth/magic-link-verify/${token}`);
        console.log('Magic link verification response:', response.data);
        
        const { token: jwtToken, user } = response.data;

        localStorage.setItem('token', jwtToken);
        localStorage.setItem('user', JSON.stringify(user));

        if (loginWithToken) {
          await loginWithToken(jwtToken, user);
        }

        setSuccess(true);
        
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } catch (error) {
        console.error('Magic link verification error:', error);
        console.error('Error response:', error.response);
        const errorMessage = error.response?.data?.error || error.message || 'Lien invalide ou expiré';
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, [token, navigate, loginWithToken]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>{t('magicLink.pageTitle')}</h1>
        
        {loading && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>{t('magicLink.verifying')}</p>
          </div>
        )}

        {error && (
          <div className="error-message">
            {error}
            <div style={{ marginTop: '20px' }}>
              <a href="/login" style={{ color: '#fff', textDecoration: 'underline' }}>
                {t('magicLink.backLoginPage')}
              </a>
            </div>
          </div>
        )}

        {success && (
          <div className="success-message" style={{ 
            backgroundColor: '#d4edda', 
            color: '#155724', 
            padding: '15px', 
            borderRadius: '5px', 
            marginBottom: '20px',
            border: '1px solid #c3e6cb',
            textAlign: 'center'
          }}>
            <p>{t('magicLink.success')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MagicLinkVerify;

